import { notificationPage } from '@environments/feature-environments/notification-page.environment';
import { dashboard } from './feature-environments/dashbord.environment';
import { teamsCampaignList } from './feature-environments/teams-campaign-list.environment';

/**
 * Configuration spécifique à l'application séparée par fonctionnalité.
 */
export const appEnvironment = {
  notificationPage,
  dashboard,
  teamsCampaignList,
};
